module.exports = __webpack_public_path__ + "static/img/history-btn.296c2032.png";